<template>
  <!-- NOTE (TEMPLATE) to build a general proposal and use it in the project as a component -->

  <div class="animated fadeIn accelerator-requests" v-if="pageLoaded">
    <b-card style="border: 0" class="mt-0 mb-0 common-card">
      <h3>کد پسادکتری: {{ proposal.requestsCode }}</h3>
      <h4 class="text-dark">وضعیت پسادکتری: {{ proposal.status }}</h4>
      <hr />
      <v-btn
        class="float-end bc-purple text-capitalize"
        elevation="0"
        v-if="tabIndex == 0"
        variant="primary"
        @click="saveDocx('doc')"
      >
        <i class="fa fa-file-word-o white--text pe-1"></i>
        <span class="white--text"> دریافت Word</span>
      </v-btn>
      <!-- docx -->
      <div v-show="false" id="doc">
        <div class="all" style="text-align: right">
          <h1
            style="
              display: inline-block;
              text-align: center;
              padding: 5px 0;
              border-bottom: 3px solid black;
            "
          >
            کد پسا دکتری:
            <span style="direction: ltr; font-family: Bahnschrift SemiBold">{{
              proposal.requestsCode
            }}</span>
          </h1>
          <div>
            <h2 style="color: black; direction: rtl">
              تاریخ خروجی:
              <span style="direction: ltr">{{ proposal.registerDate }}</span>
            </h2>
            <hr />
            <h2 style="display: inline-block; text-align: center; color: blue">
              عنوان و حمایت‌های پیشین
            </h2>
            <div>
              <ul>
                <li :class="proposal.faSubject ? 'done' : 'required'">
                  <strong>عنوان رساله دکتری: </strong>{{ proposal.faSubject }}
                </li>
                <li
                  :class="
                    proposal.initialIsSupported != null ? 'done' : 'required'
                  "
                >
                  <strong
                    >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده
                    کرده است؟
                  </strong>

                  {{ proposal.initialIsSupported ? "بله" : "خیر" }}
                </li>

                <li
                  v-if="proposal.initialIsSupported"
                  :class="proposal.initialSupportedType ? 'done' : 'required'"
                >
                  <strong> حمایت ها: </strong
                  >{{
                    proposal.initialSupportedType
                      ? options.filter(
                          (x) => x.value == proposal.initialSupportedType
                        )[0].text
                      : ""
                  }}
                </li>
                <li
                  v-if="
                    proposal.initialSupportedType == 'other' &&
                    proposal.initialIsSupported
                  "
                  :class="proposal.initialOtherSupport ? 'done' : 'required'"
                >
                  <strong>عنوان حمایت دریافتی: </strong>
                  {{ proposal.initialOtherSupport }}
                </li>
                <li
                  v-if="proposal.initialIsSupported"
                  :class="
                    proposal.initialSupportDescription ? 'done' : 'required'
                  "
                >
                  <strong>توضیحات حمایت دریافتی: </strong>
                  {{ proposal.initialSupportDescription }}
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات اصلی دوره‌
            </h2>
            <div>
              <ul>
                <li :class="proposal.faSubject ? 'done' : 'required'">
                  <strong>عنوان به زبان فارسی: </strong>{{ proposal.faSubject }}
                </li>
                <li :class="proposal.enSubject ? 'done' : 'required'">
                  <strong>عنوان به زبان انگلیسی: </strong
                  >{{ proposal.enSubject }}
                </li>
                <li :class="proposal.universityId ? 'done' : 'required'">
                  <strong>دانشگاه محل اجرای دوره: </strong>
                  {{
                    proposal.universityId
                      ? universities.filter(
                          (x) => x.id == proposal.universityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.universityId
                          )[0].text
                        : ""
                      : ""
                  }}
                </li>
                <li
                  v-if="proposal.universityId == notUniversity"
                  :class="proposal.otherUniversity ? 'done' : 'required'"
                >
                  <strong>نام دانشگاه: </strong>{{ proposal.otherUniversity }}
                </li>
                <li
                  v-if="proposal.mehvarId != notMehvar"
                  :class="proposal.mehvarId ? 'done' : 'required'"
                >
                  <strong>محور دوره: </strong>
                  {{
                    proposal.mehvarId
                      ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                        ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                            .text
                        : ""
                      : ""
                  }}
                </li>
                <li
                  v-if="proposal.mehvarId == notMehvar"
                  :class="proposal.mehvarId ? 'done' : 'required'"
                >
                  <strong>محور دوره: </strong> سایر محورها
                </li>
                <li
                  v-if="proposal.mehvarId == notMehvar"
                  :class="proposal.otherMehvars ? 'done' : 'required'"
                >
                  <strong>نام محور: </strong>{{ proposal.otherMehvars }}
                </li>
                <li>
                  <strong>ماهیت دوره: </strong>
                  <ul>
                    <li v-if="proposal.typeStudy">مطالعاتی</li>
                    <li v-if="proposal.typeSystemicDevelopmental">
                      سیستمی و توسعه‌ای
                    </li>
                    <li v-if="proposal.typePractical">کاربردی</li>
                  </ul>
                </li>
                <li>
                  <strong>حوزه دوره: </strong>
                  <ul>
                    <li v-if="proposal.zoneMedicine">پزشکی</li>
                    <li v-if="proposal.zoneAgriculture">کشاورزی</li>
                    <li v-if="proposal.zoneEnvironment">محیط زیست</li>
                    <li v-if="proposal.zoneIndustrial">صنعتی</li>
                    <li v-if="proposal.zoneBioComputing">رایانش زیستی</li>
                    <li v-if="proposal.zoneOther">سایر</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات پژوهشگر
            </h2>
            <div>
              <ul>
                <li :class="proposal.researcherName ? 'done' : 'required'">
                  <strong>نام: </strong>{{ proposal.researcherName }}
                </li>
                <li :class="proposal.researcherLastName ? 'done' : 'required'">
                  <strong>نام خانوادگی: </strong
                  >{{ proposal.researcherLastName }}
                </li>
                <li :class="proposal.researcherNatCode ? 'done' : 'required'">
                  <strong>کدملی: </strong>{{ proposal.researcherNatCode }}
                </li>
                <li :class="proposal.researcherMobile ? 'done' : 'required'">
                  <strong>تلفن همراه: </strong>{{ proposal.researcherMobile }}
                </li>
                <li :class="proposal.researcherFax ? 'done' : 'required'">
                  <strong>دورنگار: </strong>{{ proposal.researcherFax }}
                </li>
                <li :class="proposal.researcherEmail ? 'done' : 'required'">
                  <strong>پست الکترونیکی: </strong
                  >{{ proposal.researcherEmail }}
                </li>
                <li :class="proposal.researcherState ? 'done' : 'required'">
                  <strong>استان: </strong>{{ proposal.researcherState }}
                </li>
                <li :class="proposal.researcherCity ? 'done' : 'required'">
                  <strong>شهر: </strong>{{ proposal.researcherCity }}
                </li>
                <li
                  :class="proposal.researcherUniversityId ? 'done' : 'required'"
                >
                  <strong>دانشگاه محل تحصیل: </strong>
                  {{
                    proposal.researcherUniversityId
                      ? universities.filter(
                          (x) => x.id == proposal.researcherUniversityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityId
                          )[0].text
                        : "-"
                      : "-"
                  }}
                </li>
                <li
                  :class="
                    proposal.researcherUniversityOther ? 'done' : 'required'
                  "
                  v-if="proposal.researcherUniversityId == notUniversity"
                >
                  <strong>نام دانشگاه: </strong
                  >{{ proposal.researcherUniversityOther }}
                </li>
                <li :class="proposal.researcherPhDField ? 'done' : 'required'">
                  <strong>رشته تحصیلی مقطع دکتری: </strong
                  >{{ proposal.researcherPhDField }}
                </li>
                <li
                  :class="
                    proposal.researcherPhDThesisSubject ? 'done' : 'required'
                  "
                >
                  <strong>عنوان رساله دکتری: </strong
                  >{{ proposal.researcherPhDThesisSubject }}
                </li>
                <li
                  :class="
                    proposal.researcherPhDThesisDefenceDate
                      ? 'done'
                      : 'required'
                  "
                >
                  <strong>تاریخ دفاع: </strong>
                  <span style="direction: ltr">{{
                    proposal.researcherPhDThesisDefenceDate
                  }}</span>
                </li>
                <li
                  :class="
                    proposal.researcherPhDCertificateDate ? 'done' : 'required'
                  "
                >
                  <strong>تاریخ دریافت مدرک دکتری: </strong>
                  <span style="direction: ltr">{{
                    proposal.researcherPhDCertificateDate
                  }}</span>
                </li>
                <li>
                  <strong
                    >مشخصات ۳ مقاله ISI با IF بالاتر از ۱ (در ۳‌سال اخیر): </strong
                  >{{ proposal.researcherArticle ? "دارد" : "ندارد" }}
                  <ul v-if="proposal.researcherArticle">
                    <li>
                      <strong>شناسه دیجیتالی مقاله (اول): </strong>
                      <span
                        style="
                          direction: ltr;
                          font-family: Bahnschrift SemiBold;
                        "
                        >{{ proposal.researcherDoi1 }}</span
                      >
                    </li>
                    <li>
                      <strong>شناسه دیجیتالی مقاله (دوم): </strong>
                      <span
                        style="
                          direction: ltr;
                          font-family: Bahnschrift SemiBold;
                        "
                        >{{ proposal.researcherDoi2 }}</span
                      >
                    </li>
                    <li>
                      <strong>شناسه دیجیتالی مقاله (سوم): </strong>
                      <span
                        style="
                          direction: ltr;
                          font-family: Bahnschrift SemiBold;
                        "
                        >{{ proposal.researcherDoi3 }}</span
                      >
                    </li>
                  </ul>
                </li>
                <br />
                <li>
                  <strong>ثبت اختراع بین‌المللی: </strong
                  >{{
                    proposal.researcherInternationalPatent ? "دارد" : "ندارد"
                  }}
                  <div v-if="proposal.researcherInternationalPatent">
                    <b-row>
                      <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                        <strong>عنوان اختراع: </strong>
                        <span
                          style="
                            direction: ltr;
                            font-family: Bahnschrift SemiBold;
                          "
                          >{{
                            proposal.researcherInternationalPatentTitle
                          }}</span
                        >
                      </b-col>
                      <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                        <strong>سال اختراع: </strong>
                        <span
                          style="
                            direction: ltr;
                            font-family: Bahnschrift SemiBold;
                          "
                          >{{
                            proposal.researcherInternationalPatentYear
                          }}</span
                        >
                      </b-col>
                    </b-row>
                    <b-row class="my-0 py-0">
                      <b-col cols="12">
                        <strong>توضیحات اختراع: </strong>
                        <span
                          style="
                            direction: ltr;
                            font-family: Bahnschrift SemiBold;
                          "
                          >{{
                            proposal.researcherInternationalPatentDescription
                          }}</span
                        >
                      </b-col>
                    </b-row>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات مسئول دوره پسا دکتری
            </h2>
            <ul v-if="proposal.supervisors.length">
              <li :class="proposal.supervisors[0].name ? 'done' : 'required'">
                <strong>نام: </strong>{{ proposal.supervisors[0].name }}
              </li>
              <li
                :class="proposal.supervisors[0].lastName ? 'done' : 'required'"
              >
                <strong>نام خانوادگی: </strong
                >{{ proposal.supervisors[0].lastName }}
              </li>
              <li
                :class="proposal.supervisors[0].natCode ? 'done' : 'required'"
              >
                <strong>کدملی: </strong>{{ proposal.supervisors[0].natCode }}
              </li>
              <li :class="proposal.supervisors[0].mobile ? 'done' : 'required'">
                <strong>تلفن همراه: </strong
                >{{ proposal.supervisors[0].mobile }}
              </li>
              <li :class="proposal.supervisors[0].email ? 'done' : 'required'">
                <strong>پست الکترونیکی: </strong
                >{{ proposal.supervisors[0].email }}
              </li>
              <li
                :class="proposal.supervisors[0].position ? 'done' : 'required'"
              >
                <strong>سمت: </strong>{{ proposal.supervisors[0].position }}
              </li>
              <li
                :class="
                  proposal.supervisors[0].universityId ? 'done' : 'required'
                "
              >
                <strong>دانشگاه محل تحصیل: </strong>
                {{
                  universities.filter(
                    (x) => x.id == proposal.supervisors[0].universityId
                  ).length
                    ? universities.filter(
                        (x) => x.id == proposal.supervisors[0].universityId
                      )[0]
                      ? universities.filter(
                          (x) => x.id == proposal.supervisors[0].universityId
                        )[0].text
                      : "---"
                    : "---"
                }}
              </li>
              <li class="'done'">
                <strong>دانشگاه محل اشتغال: </strong>
                {{
                  proposal.supervisors[0].universityJobId
                    ? universities.filter(
                        (x) => x.id == proposal.supervisors[0].universityJobId
                      )[0]
                      ? universities.filter(
                          (x) => x.id == proposal.supervisors[0].universityJobId
                        )[0].text
                      : "-"
                    : "-"
                }}
              </li>
              <li
                :class="
                  proposal.supervisors[0].scienceCommitteeType
                    ? 'done'
                    : 'required'
                "
              >
                <strong>نوع هیئت علمی: </strong
                >{{ proposal.supervisors[0].scienceCommitteeType }}
              </li>
              <li
                :class="
                  proposal.supervisors[0].lastDegree ? 'done' : 'required'
                "
              >
                <strong>آخرین مدرک تحصیلی: </strong
                >{{ proposal.supervisors[0].lastDegree }}
              </li>
              <li
                :class="
                  proposal.supervisors[0].phdThesisSubject ? 'done' : 'required'
                "
              >
                <strong>عنوان رساله دکتری: </strong
                >{{ proposal.supervisors[0].phdThesisSubject }}
              </li>
              <li
                :class="
                  proposal.supervisors[0].academicRank ? 'done' : 'required'
                "
              >
                <strong>مرتبه علمی: </strong
                >{{ proposal.supervisors[0].academicRank }}
              </li>
              <li>
                <strong
                  >مشخصات ۵ مقاله ISI با IF بالاتر از ۱ (در ۳‌سال اخیر): </strong
                >{{ proposal.supervisors[0].article ? "دارد" : "ندارد" }}
                <ul v-if="proposal.supervisors[0].article">
                  <li>
                    <strong>شناسه دیجیتالی مقاله (اول): </strong
                    ><span
                      style="direction: ltr; font-family: Bahnschrift SemiBold"
                      >{{ proposal.supervisors[0].doi1 }}</span
                    >
                  </li>
                  <li>
                    <strong>شناسه دیجیتالی مقاله (دوم): </strong
                    ><span
                      style="direction: ltr; font-family: Bahnschrift SemiBold"
                      >{{ proposal.supervisors[0].doi2 }}</span
                    >
                  </li>
                  <li>
                    <strong>شناسه دیجیتالی مقاله (سوم): </strong
                    ><span
                      style="direction: ltr; font-family: Bahnschrift SemiBold"
                      >{{ proposal.supervisors[0].doi3 }}</span
                    >
                  </li>
                  <li>
                    <strong>شناسه دیجیتالی مقاله (چهارم): </strong
                    ><span
                      style="direction: ltr; font-family: Bahnschrift SemiBold"
                      >{{ proposal.supervisors[0].doi4 }}</span
                    >
                  </li>
                  <li>
                    <strong>شناسه دیجیتالی مقاله (پنجم): </strong
                    ><span
                      style="direction: ltr; font-family: Bahnschrift SemiBold"
                      >{{ proposal.supervisors[0].doi5 }}</span
                    >
                  </li>
                </ul>
              </li>
              <br />
              <li>
                <strong>ثبت اختراع بین‌المللی: </strong
                >{{
                  proposal.supervisors[0].internationalPatent ? "دارد" : "ندارد"
                }}
                <div v-if="proposal.supervisors[0].internationalPatent">
                  <b-row>
                    <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                      <strong>عنوان اختراع: </strong>
                      <span
                        style="
                          direction: ltr;
                          font-family: Bahnschrift SemiBold;
                        "
                        >{{
                          proposal.supervisors[0].internationalPatentTitle
                        }}</span
                      >
                    </b-col>

                    <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                      <strong>سال اختراع: </strong>
                      <span
                        style="
                          direction: ltr;
                          font-family: Bahnschrift SemiBold;
                        "
                        >{{
                          proposal.supervisors[0].internationalPatentYear
                        }}</span
                      >
                    </b-col>
                  </b-row>
                  <b-row class="my-0 py-0">
                    <b-col cols="12">
                      <strong>توضیحات اختراع: </strong>
                      <span
                        style="
                          direction: ltr;
                          font-family: Bahnschrift SemiBold;
                        "
                        >{{
                          proposal.supervisors[0].internationalPatentDescription
                        }}</span
                      >
                    </b-col>
                  </b-row>
                </div>
              </li>
              <br />
              <li>
                <strong>{{
                  proposal.supervisors[0].researchFestivals
                    ? "اعضای برگزیده جشنواره های پژوهشی بوده ام"
                    : "اعضای برگزیده جشنواره های پژوهشی نبوده ام"
                }}</strong>
              </li>
              <li
                v-if="proposal.supervisors[0].researchFestivals"
                :class="
                  proposal.supervisors[0].researchFestivalsTitle
                    ? 'done'
                    : 'required'
                "
              >
                <strong>عنوان جشنواره: </strong
                >{{ proposal.supervisors[0].researchFestivalsTitle }}
              </li>
              <br />
              <li>
                <strong>آیا استاد راهنمای متقاضی هستید؟ </strong
                >{{ proposal.supervisors[0].notSupervisor ? "خیر" : "بله" }}
              </li>
            </ul>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              مشخصات دوره
            </h2>
            <div>
              <ul>
                <li :class="proposal.abstract ? 'done' : 'required'">
                  <strong>چکیده دوره: </strong><br />
                  {{ proposal.abstract }}
                </li>
                <li :class="proposal.requestNecessity ? 'done' : 'required'">
                  <strong
                    >ضرورت اجرای دوره (در جهت دستیابی به اهداف ستاد و یا
                    راهبردها و اقدامات سند توسعه زیست فناوری): </strong
                  ><br />
                  {{ proposal.requestNecessity }}
                </li>
                <li :class="proposal.majorGoals ? 'done' : 'required'">
                  <strong>اهداف کلان دوره: </strong><br />
                  {{ proposal.majorGoals }}
                </li>
                <li :class="proposal.minorGoals ? 'done' : 'required'">
                  <strong>اهداف خرد دوره: </strong><br />
                  {{ proposal.minorGoals }}
                </li>
                <li :class="proposal.benefitsToCountry ? 'done' : 'required'">
                  <strong>مزایای دیگر برای کشور: </strong><br />
                  {{ proposal.benefitsToCountry }}
                </li>
                <li :class="proposal.methodology ? 'done' : 'required'">
                  <strong>روش شناسی (متدولوژی) و مراحل انجام دوره: </strong
                  ><br />
                  {{ proposal.methodology }}
                </li>
                <li
                  :class="
                    proposal.requestProducts.length > 0 ? 'done' : 'required'
                  "
                  v-if="proposal.requestProducts.length > 0"
                >
                  <strong
                    >دستاوردهای عینی و خروجی‌های ملموس(محصول/ محصولات و یا
                    خدمات) حاصل از اجرای دوره:
                  </strong>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="proposal.requestProducts"
                    :fields="achievmentFields"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </li>
                <li
                  :class="
                    proposal.executionHistorySimilar ? 'done' : 'required'
                  "
                >
                  <strong
                    >سابقه اجرائی یا دوره‌های مشابه در ایران یا خارج از كشور (با
                    ذكر ماخذ): </strong
                  ><br />
                  {{ proposal.executionHistorySimilar }}
                </li>
                <li
                  :class="proposal.internationalPartners ? 'done' : 'required'"
                >
                  <strong>شركای بین‌المللی در اجرای دوره : </strong><br />
                  {{ proposal.internationalPartners }}
                </li>
                <li :class="proposal.postDocLastSupports ? 'done' : 'required'">
                  <strong>حمایتهای احتمالی قبلی ستاد از دوره: </strong><br />
                  {{ proposal.postDocLastSupports }}
                </li>
                <li :class="proposal.references ? 'done' : 'required'">
                  <strong>منابع و ماخذ: </strong><br />
                  {{ proposal.references }}
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات تجاری‌سازی
            </h2>
            <h4 style="font-size: 18px">
              نوع تجاری‌سازی:
              {{
                proposal.commercializingType == "company"
                  ? "شرکت دانش بنیان"
                  : proposal.commercializingType == "accelerator"
                  ? "شتاب‌دهنده"
                  : "فاقد اطلاعات تجاری‌سازی می‌باشد"
              }}
            </h4>
            <div v-if="proposal.commercializingType == 'company'">
              <ul>
                <div v-if="proposal.companyId != notCompany">
                  <li :class="proposal.companyName ? 'done' : 'required'">
                    <strong>نام شرکت دانش بنیان: </strong
                    >{{ proposal.companyName }}
                  </li>
                  <li
                    :class="
                      proposal.companyRegistrationNumber ? 'done' : 'required'
                    "
                  >
                    <strong>شماره ثبت شرکت: </strong
                    >{{ proposal.companyRegistrationNumber }}
                  </li>
                  <li :class="proposal.companyNationalId ? 'done' : 'required'">
                    <strong>شناسه ملی شرکت: </strong
                    >{{ proposal.companyNationalId }}
                  </li>
                </div>
                <div v-else>
                  <li :class="proposal.otherCompanyName ? 'done' : 'required'">
                    <strong>نام شرکت دانش بنیان: </strong
                    >{{ proposal.otherCompanyName }}
                  </li>
                  <li
                    :class="
                      proposal.otherCompanyRegistrationNumber
                        ? 'done'
                        : 'required'
                    "
                  >
                    <strong>شماره ثبت شرکت: </strong
                    >{{ proposal.otherCompanyRegistrationNumber }}
                  </li>
                  <li
                    :class="
                      proposal.otherCompanyNationalId ? 'done' : 'required'
                    "
                  >
                    <strong>شناسه ملی شرکت: </strong
                    >{{ proposal.otherCompanyNationalId }}
                  </li>
                </div>
                <li :class="proposal.companyProducts ? 'done' : 'required'">
                  <strong>معرفی فناوری یا محصولات شرکت: </strong><br />
                  {{ proposal.companyProducts }}
                </li>
                <li :class="proposal.companyContactInfo ? 'done' : 'required'">
                  <strong>آدرس پستی / شماره تماس/ پست الکترونیک شرکت: </strong
                  ><br />
                  {{ proposal.companyContactInfo }}
                </li>
                
              </ul>
            </div>
            <ul v-else-if="proposal.commercializingType == 'accelerator'">
              <li>
                <strong class="c-purple">نام شتاب‌دهنده:</strong>

                {{ proposal.acceleratorName }}
              </li>
            </ul>
            <div v-else-if="proposal.commercializingType == 'none'">
              <div class="d-flex flex-row mb-2">
                <b-form-checkbox
                  readonly
                  v-model="proposal.commercializingObligation1"
                  @change="reactivity = !reactivity"
                ></b-form-checkbox
                ><span class="ps-2">
                  تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست توسط
                  یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه زیست فناوری
                  هیچگونه مسئولیتی در قبال درخواست من نخواهد داشت.
                </span>
              </div>
              <div class="d-flex flex-row mb-2">
                <b-form-checkbox
                  readonly
                  v-model="proposal.commercializingObligation1"
                  @change="reactivity = !reactivity"
                ></b-form-checkbox>
                <span class="ps-2">
                  تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و علمی این
                  درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های مجاز قرار خواهد
                  گرفت تا بتوانند با بررسی اطلاعات، درخواست بنده را بررسی و
                  تایید کنند.
                </span>
              </div>
            </div>
            <ul>
            <strong style="color: blue"
                  >ملاحظات مربوط به همکاری طرفین، بازار و عایدی دوره
                </strong>
                <li
                  :class="
                    proposal.interactUniversityCenters ? 'done' : 'required'
                  "
                >
                  <strong
                    >نحوه تعامل با دانشگاه یا مراکز و ملاحظات مربوط به حق
                    مالکیت:
                  </strong>
                  <br />
                  {{ proposal.interactUniversityCenters }}
                </li>
                <li :class="proposal.targetMarket ? 'done' : 'required'">
                  <strong>معرفی بازار هدف: </strong><br />{{
                    proposal.targetMarket
                  }}
                </li>
                <li
                  :class="proposal.productSalesForecast ? 'done' : 'required'"
                >
                  <strong>پیش بینی میزان فروش محصول در سه سال اول: </strong
                  ><br />
                  {{ proposal.productSalesForecast }}
                </li>
                <li :class="proposal.employment ? 'done' : 'required'">
                  <strong>میزان اشتغال زایی دوره: </strong><br />{{
                    proposal.employment
                  }}
                </li>
                <li :class="proposal.durationCooperation ? 'done' : 'required'">
                  <strong>برآورد مدت زمان همکاری: </strong
                  >{{ proposal.durationCooperation }}
                </li>
                <li
                  :class="
                    proposal.estimationProductionProjectRevenue
                      ? 'done'
                      : 'required'
                  "
                >
                  <strong>برآورد میزان تولید و عایدی دوره: </strong><br />{{
                    proposal.estimationProductionProjectRevenue
                  }}
                </li>
                <li
                  :class="
                    proposal.competitiveProductsLevelCompetitiveness
                      ? 'done'
                      : 'required'
                  "
                >
                  <strong
                    >محصولات رقیب و میزان رقابت پذیری(مقایسه قیمت) (در صورت
                    وجود): </strong
                  ><br />
                  {{ proposal.competitiveProductsLevelCompetitiveness }}
                </li>
                <li :class="proposal.productAdvantages ? 'done' : 'required'">
                  <strong>مزیت محصول نسبت به موارد مشابه و موجود: </strong
                  ><br />
                  {{ proposal.productAdvantages }}
                </li>
            </ul>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              زمان‌بندی دوره
            </h2>
            <div>
              <strong>زمان شروع: </strong>
              {{
                proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.min(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jDD/jMM/jYYYY")
                  : ""
              }}
              <br />
              <strong>زمان پایان: </strong>
              {{
                proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jDD/jMM/jYYYY")
                  : ""
              }}
              <br />
              <strong>مدت زمان: </strong>
              {{
                proposal.gantData.length > 0
                  ? (Math.max(
                      ...proposal.gantData.map((x) =>
                        new Date(
                          moment(x.dueDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    ) -
                      Math.min(
                        ...proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )) /
                      3600 /
                      24 /
                      1000 +
                    " روز"
                  : ""
              }}
              <br />
            </div>
            <b-table
              responsive
              small
              show-empty
              head-variant="dark"
              :items="proposal.gantData"
              :fields="serviceFieldsDoc"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
            </b-table>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              هزینه‌ها
            </h2>
            <div v-if="proposal.personnelCosts.length > 0">
              <h5 class="mt-5 mb-3 c-purple" style="color: blue">
                هزینه‌های پرسنلی اعم از مجری و همكاران
              </h5>

              <!-- NOTE (t-personnelCost2) previous -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.personnelCosts"
                :fields="PersonnelCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary mb-4"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(humanResourceCost)="data">
                  <div>
                    {{
                      (
                        parseInt(data.item.perPersonCost) *
                        parseInt(data.item.cooperationHour)
                      ).toLocaleString()
                    }}
                  </div>
                </template>
              </b-table>
              <!-- {{proposal.personnelCosts.map(x=>x.humanResourceCost).reduce((a,b)=>(parseInt(a)+parseInt(b)))}} -->
              <p>
                <strong>جمع کل هزینه های پرسنلی: </strong>
                {{
                  proposal.personnelCosts.length == 0
                    ? 0
                    : proposal.personnelCosts
                        .map(
                          (x) =>
                            parseInt(x.perPersonCost) *
                            parseInt(x.cooperationHour)
                        )
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                }}
                تومان
              </p>
            </div>

            <div v-if="proposal.travelExpenses.length > 0">
              <h5 class="mt-5 mb-3 c-purple" style="color: blue">
                هزینه مسافرت‌های ضروری (اعم از هزینه بلیط، اسكان، غذا، حمل و
                نقل، حق مأموریت و ...):
              </h5>

              <!-- NOTE (t-tripCost2) previous -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.travelExpenses"
                :fields="tripCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary mb-4"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
              </b-table>
              <strong>جمع کل مسافرتهای ضروری: </strong>
              {{
                proposal.travelExpenses.length == 0
                  ? 0
                  : proposal.travelExpenses
                      .map((x) => x.cost)
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      .toLocaleString()
              }}
              تومان
            </div>
            <div v-if="proposal.purchases.length > 0">
              <h5 class="mt-5 mb-3 c-purple" style="color: blue">
                هزینه دستگاه‌ها، وسایل و مواد مورد نیازكه باید از محل اعتبار طرح
                خریداری شوند:
              </h5>

              <!-- NOTE (t-deviceCost2) previous -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.purchases"
                :fields="deviceCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(totalPrice)="data">
                  <div>
                    {{
                      (
                        parseInt(data.item.number) *
                        parseInt(data.item.perPrice)
                      ).toLocaleString()
                    }}
                  </div>
                </template>
              </b-table>
              <strong>جمع کل هزینه دستگاه‌ها: </strong>
              {{
                proposal.purchases.length == 0
                  ? 0
                  : proposal.purchases
                      .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      .toLocaleString()
              }}
              تومان
            </div>

            <div v-if="proposal.participationOrganizationBudget.length > 0">
              <h5 class="mt-5 mb-3 c-purple" style="color: blue">
                میزان مشارکت سایر موسسات:
              </h5>

              <!-- NOTE (t-orgCost2) previous -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.participationOrganizationBudget"
                :fields="OrgCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
              </b-table>
              <strong>جمع کل مشارکت موسسات: </strong>
              {{
                proposal.participationOrganizationBudget.length == 0
                  ? 0
                  : proposal.participationOrganizationBudget
                      .map((x) => x.totalPrice)
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      .toLocaleString()
              }}
              تومان
            </div>
            <div
              v-show="
                proposal.otherCosts
                  .map((x) => x.totalPrice)
                  .reduce((a, b) => parseInt(a) + parseInt(b), 0) > 0
              "
            >
              <h5 class="mt-5 mb-3 c-purple" style="color: blue">
                هزینه‌های دیگر:
              </h5>
              <!-- NOTE (t-otherCost2) previous -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.otherCosts"
                :fields="otherCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
              </b-table>
              <p>
                <strong>جمع کل سایر هزینه‌ها: </strong>
                {{
                  proposal.otherCosts.length == 0
                    ? 0
                    : proposal.otherCosts
                        .map((x) => x.totalPrice)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                }}
                تومان
              </p>
            </div>
            <h3>
              <strong>جمع کل هزینه‌ها: </strong>
              {{
                (tPrice = (
                  (proposal.personnelCosts.length == 0
                    ? 0
                    : proposal.personnelCosts
                        .map(
                          (x) =>
                            parseInt(x.perPersonCost) *
                            parseInt(x.cooperationHour)
                        )
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                  (proposal.travelExpenses.length == 0
                    ? 0
                    : proposal.travelExpenses
                        .map((x) => x.cost)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                  (proposal.purchases.length == 0
                    ? 0
                    : proposal.purchases
                        .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                  (proposal.otherCosts.length == 0
                    ? 0
                    : proposal.otherCosts
                        .map((x) => x.totalPrice)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                ).toLocaleString())
              }}
              تومان
            </h3>
            <h3>
              <strong>میزان اعتبار مورد نیاز از ستاد زیست فناوری: </strong>
              {{ computedTotalCost.toLocaleString() }}
              تومان
            </h3>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              تعهدات
            </h2>
            <div>
              <ul>
                <li v-if="proposal.promiseArrays[0]">
                  این طرح در مدت زمان اعلام شده در پروپوزال انجام می‌گردد و
                  مسئولیت تاخیر در انجام طرح بر عهده مجری می‌باشد. مدت زمان:
                  {{
                    proposal.gantData.length > 0
                      ? (Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        ) -
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.startDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )) /
                          3600 /
                          24 /
                          1000 +
                        " روز"
                      : ""
                  }}
                </li>
                <li v-if="proposal.promiseArrays[1]">
                  این طرح با بودجه اعلام شده در پروپوزال انجام می‌گردد. هزینه
                  انجام:
                  {{
                    (tPrice = (
                      (proposal.personnelCosts.length == 0
                        ? 0
                        : proposal.personnelCosts
                            .map(
                              (x) =>
                                parseInt(x.perPersonCost) *
                                parseInt(x.cooperationHour)
                            )
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                      (proposal.travelExpenses.length == 0
                        ? 0
                        : proposal.travelExpenses
                            .map((x) => x.cost)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                      (proposal.purchases.length == 0
                        ? 0
                        : proposal.purchases
                            .map(
                              (x) => parseInt(x.perPrice) * parseInt(x.number)
                            )
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                      (proposal.otherCosts.length == 0
                        ? 0
                        : proposal.otherCosts
                            .map((x) => x.totalPrice)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                    ).toLocaleString())
                  }}
                  تومان
                </li>
                <li v-if="proposal.promiseArrays[2]">
                  کلیه حقوق مادی و معنوی این طرح متعلق به ستاد زیست فناوری
                  می‌باشد.
                </li>
                <li v-if="proposal.promiseArrays[3]">
                  توافق بین دانشگاه و صنعت در خصوص دستاوردهای طرح وجود دارد.
                </li>
                <li v-if="proposal.promiseArrays[4]">
                  نحوه و مسیر تجاری سازی طرح مشخص است و مستندات ارائه شده است.
                </li>
                <li v-if="proposal.promiseArrays[5]">
                  بهره‌بردار نهایی طرح مشخص است و مستندات ارائه شده است. نام
                  بهره‌بردار:
                  {{
                    proposal.researcherName + " " + proposal.researcherLastName
                  }}
                </li>
                <li v-if="proposal.promiseArrays[6]">
                  حداقل 1 مقاله ISI معتبر به عنوان خروجی طرح تعهد می‌شود.
                </li>
                <li v-if="proposal.promiseArrays[7]">
                  تمامی گزارش‌ها پیشرفت در موعد مقرر مطابق با گانت چارت انجام
                  خواهد شد.
                </li>
                <li v-if="proposal.promiseArrays[8]">
                  کلیه گزارش‌ها و خروجی‌ها و دستاوردهای طرح در پایان انجام طرح
                  به ستاد زیست فناوری ارسال و تحویل داده می‌شود.
                </li>
                <li v-if="proposal.promiseArrays[9]">
                  کلیه اصلاحات در مورد مقرر و طی 2 هفته توسط مجری انجام و در
                  سایت بارگذاری می‌گردد.
                </li>
                <li v-if="proposal.promiseArrays[10]">
                  ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد نمی‌کند و
                  به منزله ثبت درخواست متقاضی است.
                </li>
                <li v-if="proposal.promiseArrays[11]">
                  سوابق پژوهشگر با موضوع دوره منطبق است.
                </li>
                <li v-if="proposal.promiseArrays[12]">
                  سوابق استاد راهنما با موضوع دوره منطبق است.
                </li>
                <li v-if="proposal.promiseArrays[13]">
                  کلیه موارد فوق مورد تایید اینجانب
                  {{
                    proposal.researcherName + " " + proposal.researcherLastName
                  }}
                  به عنوان مجری طرح و همکاران می‌باشد.
                </li>
              </ul>
            </div>
          </div>
          <hr />
        </div>
      </div>
      <!-- docx -->
      <b-tabs class="mt-8" pills v-model="tabIndex">
        <b-tab title="چکیده طرح" lazy>
          <PostDoc
            :proposal="proposal"
            :universities="universities"
            :mehvars="mehvars"
            :companies="companies"
            :isLoaded="pageLoaded"
          />
        </b-tab>
        <b-tab title="اطلاعات تجاری‌سازی">
          <v-row class="px-4">
            <v-col>
              <h4 class="c-dark mt-2">
                نوع تجاری‌سازی:
                {{
                  proposal.commercializingType == "company"
                    ? "شرکت دانش بنیان"
                    : proposal.commercializingType == "accelerator"
                    ? "شتاب‌دهنده"
                    : "فاقد اطلاعات تجاری‌سازی می‌باشد"
                }}
              </h4>
            </v-col>
          </v-row>
          <b-card-body>
            <b-card-text>
              <div v-if="proposal.commercializingType == 'company'">
                <ul>
                  <div v-if="proposal.companyId != notCompany">
                    <li>
                      <strong class="c-purple">نام شرکت دانش بنیان: </strong
                      >{{ proposal.companyName }}
                    </li>
                    <li>
                      <strong class="c-purple">شماره ثبت شرکت: </strong
                      >{{ proposal.companyRegistrationNumber }}
                    </li>
                    <li>
                      <strong class="c-purple">شناسه ملی شرکت: </strong
                      >{{ proposal.companyNationalId }}
                    </li>
                  </div>
                  <div v-else>
                    <li>
                      <strong class="c-purple">نام شرکت دانش بنیان: </strong
                      >{{ proposal.otherCompanyName }}
                    </li>
                    <li>
                      <strong class="c-purple">شماره ثبت شرکت: </strong>
                      {{ proposal.otherCompanyRegistrationNumber }}
                    </li>
                    <li>
                      <strong class="c-purple">شناسه ملی شرکت: </strong
                      >{{ proposal.otherCompanyNationalId }}
                    </li>
                  </div>
                  <li>
                    <strong class="c-purple"
                      >معرفی فناوری یا محصولات شرکت:
                    </strong>
                    {{ proposal.companyProducts }}
                  </li>
                  <li>
                    <strong class="c-purple"
                      >آدرس پستی / شماره تماس/ پست الکترونیک شرکت:
                    </strong>
                    {{ proposal.companyContactInfo }}
                  </li>
                </ul>
                
              </div>
              <ul v-else-if="proposal.commercializingType == 'accelerator'">
                <li>
                  <strong class="c-purple">نام شتاب‌دهنده:</strong>

                  {{ proposal.acceleratorName }}
                </li>
              </ul>
              <div v-else-if="proposal.commercializingType == 'none'">
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    readonly
                    v-model="proposal.commercializingObligation1"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox
                  ><span class="ps-2">
                    تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست توسط
                    یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه زیست
                    فناوری هیچگونه مسئولیتی در قبال درخواست من نخواهد داشت.
                  </span>
                </div>
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    readonly
                    v-model="proposal.commercializingObligation1"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox>
                  <span class="ps-2">
                    تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و علمی
                    این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های مجاز قرار
                    خواهد گرفت تا بتوانند با بررسی اطلاعات، درخواست بنده را
                    بررسی و تایید کنند.
                  </span>
                </div>
              </div>
              <hr>
              <h5 class="c-dark mt-3">
                  ملاحظات مربوط به همکاری طرفین، بازار و عایدی دوره
                </h5>
                <ul class="ps-2">
                  <li>
                    <strong class="c-purple"
                      >نحوه تعامل با دانشگاه یا مراکز و ملاحظات مربوط به حق
                      <strong class="c-purple">مالکیت: </strong></strong
                    >
                    {{ proposal.interactUniversityCenters }}
                  </li>
                  <li>
                    <strong class="c-purple">معرفی بازار هدف: </strong
                    >{{ proposal.targetMarket }}
                  </li>
                  <li>
                    <strong class="c-purple"
                      >پیش بینی میزان فروش محصول در سه سال اول:
                    </strong>
                    {{ proposal.productSalesForecast }}
                  </li>
                  <li>
                    <strong class="c-purple">میزان اشتغال زایی دوره: </strong
                    >{{ proposal.employment }}
                  </li>
                  <li>
                    <strong class="c-purple">برآورد مدت زمان همکاری: </strong
                    >{{ proposal.durationCooperation }}
                  </li>
                  <li>
                    <strong class="c-purple"
                      >برآورد میزان تولید و عایدی دوره:
                    </strong>
                    {{ proposal.estimationProductionProjectRevenue }}
                  </li>
                  <li>
                    <strong class="c-purple"
                      >محصولات رقیب و میزان رقابت پذیری(مقایسه قیمت) (در صورت
                      وجود):
                    </strong>
                    {{ proposal.competitiveProductsLevelCompetitiveness }}
                  </li>
                  <li>
                    <strong class="c-purple"
                      >مزیت محصول نسبت به موارد مشابه و موجود:
                    </strong>
                    {{ proposal.productAdvantages }}
                  </li>
                </ul>
            </b-card-text>
          </b-card-body>
        </b-tab>
        <b-tab title="فایل های تکمیلی">
          <Files :files="proposal.uploadedFiles" :isLoaded="pageLoaded" />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import PostDoc from "./../../components/AcceleratorPostDoc";
import Files from "./../../components/UploadedFiles";
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("./../../components/sarmadGantt");
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    Select2, // NOTE (COMPONENT) component of select2 plugin
    PostDoc,
    Files,
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
  },
  data() {
    return {
      refereeErrorHandler: false,
      expireDisable: false,
      pageLoaded: false,
      statusDictionary: [
        { en: "Done", fa: "تمام" },
        { en: "NotDone", fa: "ناتمام" },
        { en: "Expired", fa: "منقضی" },
      ],
      rejectCause: [],
      rejectOptions: [],
      infoo: "",
      promises: {},
      eduGradeOptions: [
        "--مقطع را انتخاب کنید",
        "کارشناسی",
        "کارشناسی ارشد",
        "دکتری",
        "دکتری حرفه ای",
      ],
      fileBusy: true,
      selectedStatus: null,
      selectedSituation: "",
      comments: "",
      reviewersData: [],
      reviewersFields: [],
      judgements: [],
      selectedJudgement: {},
      journalsFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام" },
        { key: "message", label: "پیام" },
        { key: "date", label: "تاریخ" },
      ],
      judgementFields: [
        { key: "index", label: "#" },
        { key: "status", label: "وضعیت" },
        { key: "referee", label: "داور" },
        { key: "decision", label: "تصمیم" },
        { key: "judgeDate", label: "تاریخ داوری" },
        { key: "description", label: "توضیحات" },
      ],
      reviewers: [],
      situationsOptions: [
        { id: 1, eng: "registered", text: "ثبت شده" },
        { id: 2, eng: "underSupervision", text: "درحال بررسی" },
        { id: 3, eng: "inviteReviewers", text: "در دست داوری" },
        { id: 4, eng: "reviewDone", text: "جمع بندی نظرات داوران" },
        { id: 5, eng: "approve", text: "پذیرش اولیه" },
        { id: 6, eng: "corrected", text: "اصلاح شده" },
        { id: 7, eng: "finalAccept", text: "تایید نهایی" },
        { id: 8, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 9, eng: "reject", text: "رد شده است" },
        { id: 10, eng: "declined", text: "لغو" },
      ],
      selectedReferee: "",
      adminMessage: "",
      reportItems: [],
      reportFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      fileItems: [],
      filesFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      haveReferee: null,
      contract: null,

      acc: 0,
      moment: moment,
      show: false,
      checkbox: "",
      checkbox2: "",
      busy: false,
      initial: {},
      doi: "",
      code: {},
      source: "",
      specs: {},
      colleaguesData: [],
      selectedColleague: "",
      executor: {},
      proposal: {
        initialIsSupported: null,
      },
      colleague: {},
      universities: [],
      mehvars: [],
      fileFilter: "",
      zone: new Array(6).fill(false),
      tabIndex: 0,
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      drPosition: ["مربی", "استادیار", "دانشیار", "استاد‌تمام"],
      committieType: ["وزارت علوم", "وزارت بهداشت"],
      lastDegree: ["کارشناسی", "کارشناسی ارشد", "دکتری"],
      support: "",
      supportSetad: "",
      dr: {},
      selectedMehvar: 0,
      taahol: "",
      DoiItem: [],
      DoiField: [
        { key: "subject", label: "عنوان" },
        { key: "mag", label: "مجله" },
        { key: "if", label: "IF" },
        { key: "year", label: "سال" },
      ],
      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی (ماه)" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        // { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه کل سفر" },
      ],
      perCosts: [
        {
          value: "دلار",
          text: "دلار",
        },
        {
          value: "تومان",
          text: "تومان",
        },
      ],
      perPrices: [
        {
          value: "دلار",
          text: "دلار",
        },
        {
          value: "تومان",
          text: "تومان",
        },
      ],
      adminToReferee: "",
      options1: [
        {
          value: "کارشناسی",
          text: "کارشناسی",
        },
        {
          value: "کارشناسی ارشد",
          text: "کارشناسی ارشد",
        },
        {
          value: "دکتری",
          text: "دکتری",
        },
      ],
      options2: [
        {
          value: "تمام وقت",
          text: "تمام وقت",
        },
        {
          value: "پاره وقت",
          text: "پاره وقت",
        },
      ],
      sources: [
        {
          value: "داخلی",
          text: "داخلی",
        },
        {
          value: "خارجی",
          text: "خارجی",
        },
      ],

      deviceTypes: [
        { value: "مصرفی", text: "مصرفی" },
        { value: "سرمایه‌ای", text: "سرمایه‌ای" },
      ],
      PersonnelCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "degree", label: "میزان تحصیلات" },
        { key: "cooperationType", label: "نوع همکاری" },
        { key: "cooperationHour", label: "هزینه نفر ساعت (تومان)" },
        { key: "perPersonCost", label: "نفر ساعت مورد نیاز" },
        {
          key: "humanResourceCost",
          label: "هزینه نیروی انسانی (تومان)",
        },
      ],
      inventionItem: [],
      rejectMessage: "",
      inventionField: [
        { key: "subject", label: "عنوان" },
        { key: "Iyear", label: "سال" },
        { key: "description", label: "توضیحات" },
      ],
      inventionFieldMaster: [
        { key: "Msubject", label: "عنوان" },
        { key: "Myear", label: "سال" },
        { key: "Mdescription", label: "توضیحات" },
      ],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "showName", label: "نام فایل" },
        { key: "title", label: "عنوان فایل" },
        { key: "description", label: "توضیحات" },
        { key: "url", label: "دریافت" },
      ],
      file: null,
      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی (ماه)" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      additionalFiles: {
        zero: { uploadPercentage: 0 },
        research: { uploadPercentage: 0 },
        industry: { uploadPercentage: 0 },
        agreement: { uploadPercentage: 0 },
        others1: { uploadPercentage: 0 },
        others2: { uploadPercentage: 0 },
        others3: { uploadPercentage: 0 },
      },
      otherCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نوع هزینه‌ها" },
        { key: "totalPrice", label: "مبلغ" },
      ],
      allCostItem: [
        { name: "پرسنلی ", totalPrice: 0 },
        { name: "ارتباطات، حمل ونقل ، پست ، دورنویس و باربری", totalPrice: 0 },
        { name: "هزینه های پیش بینی نشده", totalPrice: 0 },
      ],
      allCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نوع هزینه‌ها" },
        { key: "پرسنلی ", label: "پرسنلی" },
      ],
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود)",
        },
        { key: "totalPrice", label: "میزان مشارکت (تومان)" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        // { key: "consumable", label: "مصرفی" },
        // { key: "fund", label: "سرمایه‌ای" },
        { key: "type", label: "نوع" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد/میزان" },
        { key: "perPrice", label: "قیمت واحد به تومان" },
        { key: "totalPrice", label: "قیمت کل به تومان" },
      ],
      uploadedFiles: new Array(10).fill({
        title: "",
        description: "",
      }),
      otherFiles: new Array(10).fill({
        isUploaded: false,
      }),
      myshow: false,
      config: {
        locale: {
          name: "en",
        },
        height: 50,
        list: {
          rows: {},
          columns: {
            data: {
              id: {
                id: "id",
                data: "id",
                width: 50,
                header: {
                  content: "ردیف",
                },
              },
              label: {
                id: "label",
                data: "label",
                width: 200,
                header: {
                  content: "نام فعالیت",
                },
              },
              start: {
                id: "start",
                data: (start) => moment(start).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ آغاز",
                },
              },
              end: {
                id: "end",
                data: (end) => moment(end).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ پایان",
                },
              },
            },
          },
        },
        chart: {
          time: {
            zoom: 12,
          },
          items: {},
        },
      },
      background: [
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
      ],
      isLoaded: true,

      companies: [],
    };
  },
  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    getInfo() {
      this.isLoaded = false;

      let acc = 0;
      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه ها",
            })
          );
          this.universities.unshift({
            id: 0,
            name: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });
          acc++;
        })
        .catch((err) => {
          console.log(err);
        });
      ///////////////////////////////////////////////
      this.$http
        .post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
          acc++;
        })
        .catch((err) => {
          console.log(err);
        });
      ///////////////////////////////////////////////
      this.$http
        .post(
          this.baseUrl + "/setad/options/companies",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.companies = res.data;
          this.companies.forEach((x) => {
            x.text = x.name;
          });
          this.companies.push(
            new Object({
              id: this.notCompany,
              text: "سایر شرکت ها",
            })
          );

          acc++;
        })
        .catch((err) => {
          console.log(err);
        });

      //get info
      this.$http
        .post(
          this.baseUrl + "/setad/accelerator/request/postDoc/getInfo",
          {
            requestId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.proposal = res.data;
          this.isLoaded = true;
          acc++;
          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
          }
          setTimeout(() => {
            // NOTE (m-setTimeout) to set timeout for 200 ms
            this.pageLoaded = true;
          }, 200);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    computedTotalCost() {
      let tempPrice =
        (this.proposal.personnelCosts.length == 0
          ? 0
          : this.proposal.personnelCosts
              .map(
                (x) => parseInt(x.perPersonCost) * parseInt(x.cooperationHour)
              )
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.travelExpenses.length == 0
          ? 0
          : this.proposal.travelExpenses
              .map((x) => x.cost)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.purchases.length == 0
          ? 0
          : this.proposal.purchases
              .map((x) => parseInt(x.perPrice) * parseInt(x.number))
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.otherCosts.length == 0
          ? 0
          : this.proposal.otherCosts
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) -
        (this.proposal.participationOrganizationBudget.length == 0
          ? 0
          : this.proposal.participationOrganizationBudget
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0));

      if (tempPrice > 0) return tempPrice;
      else return 0;
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.getInfo();
  },
  updated() {},
};
</script>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style>
